import React, { useState, useEffect } from 'react';

/* Image */
import logo from "./logo.png";

/* Libraries */
import { Button, Paper, TextField, Tooltip, Grid2 as Grid, Typography  } from '@mui/material';
import { AccountCircleRounded as AccountCircleRoundedIcon, Lock as LockIcon, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon, RotateLeft as RotateLeftIcon, SwapHoriz as SwapHorizIcon } from '@mui/icons-material';
import ReactCardFlip from 'react-card-flip';
import { QRCodeSVG } from 'qrcode.react';
import { toast } from 'react-toastify';
import ReactCodeInput from 'react-code-input';

/* Services */
import { authentication } from '../../services/GraphService';

const classes = {
    paper: {
        margin: "0 auto",
        width: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: '10px 20px',
        boxShadow: '10px 10px 30px 5px #888888',
        position: 'relative',
        blurRadius: '10px',

    },
    parent: {
        display: 'flex',
    },
    inputIcon: {
        color: '#696868',
        marginRight: '5px',
        '& .MuiSvgIcon-root': {
            fontSize: '10rem!important'
        }
    },
    visibilityIcon: {
        color: '#696868',
        marginLeft: '5px',
        cursor: 'pointer'
    },
    swapIcon: {
        color: '#696868',
        cursor: 'pointer',
        fontSize: '40px'
    },
    error: {
        margin: 0,
        color: 'red',
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 500
    },
    errorDefault: {
        margin: 0,
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 500
    },
    tooltip: {
        fontFamily: 'Manrope',
        fontWeight: 500,
        fontSize: '12px',
        padding: '10px'
    },
    inputPropsStyle: {
        marginTop: '5px',
        width: '83%',
        backgroundColor: 'transparent',
        padding: '0 0 5px 0',
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 500
    },
    inputPropsLabelStyle: {
        fontWeight: 500,

        '& .MuiInput-underline:before': {
            borderBottom: '2px solid #ccc',
        },
        '& .MuiInput-underline:after': {
            borderBottom: '2px solid #ff6230',
        },
        '& .MuiInput-underline:focused:not(.Mui-disabled):before': {
            borderBottom: '2px solid #ff6230',
        },
        '& .MuiInputBase-root': {               //DELETE THIS LINE !!!!
            backgroundColor: 'transparent',
            padding: '10px',
            marginTop: '20px',
            paddingLeft: '10px',
            borderRadius: '3px',
            height: '45px',
            fontSize: '14px',

            // boxShadow: 'inset 3px 3px 13px rgb(156, 158, 159), inset 2px 2px 2px' 
        }
    },
    title: {
        fontWeight: 600,
        // fontStyle: 'italic', 
        letterSpacing: '1.5px',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontFamily: 'Manrope, sans-serif',
    },
    textSized: {
        margin: 0,
        fontSize: '2rem',
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 600
    },
    mainImage: {
        width: '300px',
        marginTop: '-16px'
    },
    arrowBackIcon: {
        position: 'absolute',
        left: '15px',
        top: '30px',
        cursor: 'pointer',
        color: '#6495ed',
        fontSize: '2rem'
    },
    iconInfo: {
        color: '#6495ed',
        marginTop: '-3px',
        marginLeft: '5px',
        cursor: 'help'
    },
    buttonReset: {
        marginBottom: '5px',
        borderRadius: '4px',
        padding: '6px 16px',
        fontFamily: 'Manrope, sans-serif',

    },
    buttonLogin: {
        borderRadius: '4px',
        marginTop: '10px',
        marginBottom: '15px',
        padding: '10px 20px',
        fontFamily: 'Manrope, sans-serif',
        backgroundColor: "#ff5100",
        textTransform: 'capitalize',

        '&:hover': {
            background: '#ff4830',

        }
    },
    buttonForgetPassword: {
        paddingLeft: 0,
        width: '100%',
        textAlign: 'center',
        paddingBottom: 0,
        textTransform: 'none',
        fontSize: '14px!important',
        fontFamily: 'Manrope, sans-serif',
        color: '#ff5100',
        '&:hover': {
            color: '#ff3830'
        }
    }
}

const Login = () => {
    const [isFlipped, setIsFlipped] = useState(false);
    const [visibility, setVisibility] = useState(false);

    const [authorizationForm, setAuthorizationForm] = useState(false);
    const [needQr, setNeedQr] = useState(false);
    const [qrInfo, setQrInfo] = useState({});
    const [defaultCodeError, setDefaultCodeError] = useState(true);
    const [code, setCode] = useState('');
    const [isWrongCode, setIsWrongCode] = useState(false);

    const [hiddenSecretKey, setHiddenSecretKey] = useState(true);

    const [authorizationValues, setAuthorizationValues] = useState({
        username: '',
        password: ''
    });

    useEffect(() => {
        if(code?.length === 6) {
            setTimeout(() => {
                handleLogin();
            }, 1000);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    /* Handle change values */
    const handleChange = (event) => {
        const name = event?.target?.name;
        const value = event?.target?.value;

        setAuthorizationValues(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        });
    }

    /* Handle login */
    const handleLogin = () => {
        authentication(authorizationValues, code)
            .then(result => {
                const token = result?.token?.access_token;

                if (isWrongCode) { setIsWrongCode(false); }

                if (token) {
                    sessionStorage.setItem('token', token);
                    sessionStorage.setItem('passwordExpiration', result?.password_expires_at);
                    window.location.reload();
                } else {
                    toast?.dismiss();

                    if (result?.status === 'invalid_user' || result?.status === 'invalid_otp') {
                        if (result?.status === 'invalid_otp') {
                            setIsWrongCode(true);
                        }

                        return toast.error(result?.message);
                    }

                    setAuthorizationForm(true);

                    if (result?.status === "otp_not_configured") {
                        setNeedQr(true);
                        setQrInfo(result?.otp_secret);
                    }
                }
            })
            .catch(error => {
                console.error("Authentication failed:", error);
            });
    }

    /* Handle key "Enter" */
    const handleKeyDown = (event) => {
        /* Key code 13 = Enter */
        if (event?.keyCode === 13 && authorizationValues?.username && authorizationValues?.password) {
            event?.preventDefault();

            handleLogin();
        }
    }

    /* Handle change code input */
    const handleChangeCode = (value) => {
        if (code && code?.length === 6 && defaultCodeError) {
            setDefaultCodeError(false);
        }

        setCode(value);
    }

    /* Handle toggle secret key visibility */
    const handleToggleSecretKeyVisibility = () => {
        setHiddenSecretKey(!hiddenSecretKey);
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5rem' }}>
            <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal" containerClassName={classes.parent}>
                <Paper sx={classes.paper}>
                    <img src={logo} style={{ width: '100%', margin: '50px 0px 0px' }} alt="" />

                    <Typography variant="h5" style={{ marginBottom: 50, fontFamily: 'Manrope', letterSpacing: 2, color: '#636468', fontStyle: 'italic' }}> Енергия с покритие </Typography>

                    <Grid container spacing={2} sx={classes.root}>
                        <Grid item size={12}>
                            <TextField
                                label="Потребителско име"
                                name="username"
                                margin="dense"
                                fullWidth
                                variant="standard"
                                value={authorizationValues?.username}
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                autoComplete='off'
                                disabled={authorizationForm}
                                slotProps={{
                                    input: {
                                        sx: {
                                            fontFamily: 'Manrope'
                                        },
                                        startAdornment: (
                                            <AccountCircleRoundedIcon position="start" sx={classes.inputIcon} />
                                        )
                                    },
                                    inputLabel: {
                                        sx: {
                                            fontFamily: 'Manrope',
                                            color: '#696868',
                                            fontSize: '18px',
                                            padding: '0px',
                                            fontWeight: '500',
                                            '&.Mui-focused': {
                                                color: '#ff6230',
                                            }
                                        },

                                    }
                                }}
                                sx={classes.inputPropsLabelStyle}
                                helperText={''}
                            />
                        </Grid>

                        <Grid item size={12} style={{ position: 'relative' }}>
                            <TextField
                                label="Парола"
                                name="password"
                                type={visibility ? 'text' : 'password'}
                                margin="dense"
                                fullWidth
                                autoComplete='off'
                                disabled={authorizationForm}
                                variant="standard"
                                value={authorizationValues?.password}
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                slotProps={
                                    {
                                        input: {
                                            sx: {
                                                fontFamily: 'Manrope'
                                            },
                                            startAdornment: (
                                                <LockIcon position="start" sx={classes.inputIcon} />
                                            ),
                                            endAdornment: (
                                                authorizationValues?.password && !authorizationForm
                                                    ?   visibility 
                                                            ?   <Tooltip
                                                                    title="Скрий паролата"
                                                                    placement="top"
                                                                    arrow
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            style: {
                                                                                backgroundColor: '#636468',
                                                                                fontFamily: 'Manrope',
                                                                                fontSize: 12,
                                                                                letterSpacing: '0.5px',
                                                                                padding: '5px 10px'
                                                                            }
                                                                        },
                                                                        popper: {
                                                                            modifiers: [
                                                                                {
                                                                                    name: 'offset',
                                                                                    options: {
                                                                                        offset: [0, 4] // set distance from the icon for the tooltip
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }}
                                                                >
                                                                    <VisibilityIcon sx={classes.visibilityIcon} onClick={() => setVisibility(!visibility)} />
                                                                </Tooltip>
                                                            :   <Tooltip
                                                                    title="Покажи паролата"
                                                                    placement="top"
                                                                    arrow
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            style: {
                                                                                backgroundColor: '#636468',
                                                                                fontFamily: 'Manrope',
                                                                                fontSize: 12,
                                                                                letterSpacing: '0.5px',
                                                                                padding: '5px 10px'
                                                                            }
                                                                        },
                                                                        popper: {
                                                                            modifiers: [
                                                                                {
                                                                                    name: 'offset',
                                                                                    options: {
                                                                                        offset: [0, 4] // set distance from the icon for the tooltip
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }}
                                                                >
                                                                    <VisibilityOffIcon sx={classes.visibilityIcon} onClick={() => setVisibility(!visibility)} />
                                                                </Tooltip>
                                                    :   <></>


                                            )
                                        },
                                        inputLabel: {
                                            sx: {
                                                fontFamily: 'Manrope',
                                                color: '#696868',
                                                fontSize: '18px',
                                                padding: '0px',
                                                fontWeight: '500',
                                                '&.Mui-focused': {
                                                    color: '#ff6230'
                                                }
                                            },

                                        }
                                    }
                                }
                                sx={classes.inputPropsLabelStyle}
                                helperText={''}
                            />
                        </Grid>

                        {/* <Grid item size={12}>
                            <Button 
                                sx={classes.buttonForgetPassword} 
                                onClick={() => { toggleFlipped() }} 
                                startIcon={<RotateLeftIcon />}
                            > 
                                Забравена парола
                            </Button>
                        </Grid> */}

                        <Grid item size={12} sx={{ textAlign: 'center' }}>
                            <Button 
                                sx={classes.buttonLogin} 
                                fullWidth 
                                variant="contained" 
                                size="small" 
                                onClick={handleLogin} 
                                disabled={!authorizationValues?.username || !authorizationValues?.password || authorizationForm}
                            >
                                Вход
                            </Button>
                        </Grid>

                        {   authorizationForm
                                ?   <>
                                        {   needQr &&
                                            <Grid item size={12} sx={{ margin: '10px 0px', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
                                                {
                                                    hiddenSecretKey
                                                        ?   <QRCodeSVG value={qrInfo?.provisioning_uri} size={180} />
                                                        :   <div style={{ height: 180, width: 180, fontSize: '16px', fontFamily: 'Manrope', display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                                                <span> {qrInfo?.secret} </span>
                                                            </div>
                                                }

                                                <div style={{ position: 'relative' }}>
                                                    <Tooltip
                                                        title={hiddenSecretKey ? "Покажи скрития код за въвеждане" : "Покажи QR кода"}
                                                        placement="top"
                                                        arrow
                                                        slotProps={{
                                                            tooltip: {
                                                                style: {
                                                                    backgroundColor: '#636468',
                                                                    fontFamily: 'Manrope',
                                                                    fontSize: 12,
                                                                    letterSpacing: '0.5px',
                                                                    padding: '5px 10px'
                                                                }
                                                            },
                                                            popper: {
                                                                modifiers: [
                                                                    {
                                                                        name: 'offset',
                                                                        options: {
                                                                            offset: [0, 4] // set distance from the icon for the tooltip
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }}
                                                    >
                                                        <SwapHorizIcon sx={classes.swapIcon} onClick={handleToggleSecretKeyVisibility} />
                                                    </Tooltip>
                                                </div>
                                            </Grid>
                                        }

                                        <Grid item size={12} sx={{ textAlign: 'center' }}>
                                            <Typography variant="h6" style={{ fontFamily: 'Manrope', letterSpacing: 2, color: '#636468', fontStyle: 'italic' }}> Въведете вашият код </Typography>

                                            <ReactCodeInput
                                                id="codeInput"
                                                name="code"
                                                inputMode="numeric"
                                                type='number'
                                                fields={6}
                                                value={code}
                                                className={`custom-code-input ${isWrongCode ? 'custom-code-input--error' : code?.length === 6 ? 'custom-code-input--success' : ''}`}
                                                autoFocus
                                                onChange={handleChangeCode}
                                            />
                                        </Grid>
                                    </>
                                :   null
                        }
                    </Grid>
                </Paper>
                {/*      back card content */}
                <></>
            </ReactCardFlip>
        </div>


    );
}

export default Login;